import { create } from 'zustand';

export type UserRole =
  | 'developer-portal'
  | 'admin-portal'
  | 'publisher-portal'
  | null;

export interface RoleInputState {
  role: UserRole;
  userAllowed: boolean | null | undefined; // Izinkan `undefined`
}

interface DraftInputState {
  drafts: RoleInputState[];
}

interface WhitelistAction {
  setValue<K extends keyof RoleInputState>(
    key: K,
    value: RoleInputState[K],
  ): void;
  setDraft(draft: RoleInputState): void;
  clear(): void;
  updateDraft(role: UserRole, changes: Partial<RoleInputState>): void;
}

type DraftStoreType = DraftInputState & WhitelistAction;

export const useDraftInputState = create<DraftStoreType>((set) => ({
  drafts: [],
  setValue(key, value) {
    set((state) => ({
      [key]: value,
    }));
  },
  setDraft: (draft: RoleInputState) => {
    set((state) => {
      state.drafts.push(draft);
      return state;
    });
  },
  clear: () => {
    set((state) => ({ drafts: [] }));
  },
  updateDraft: (role, changes) => {
    set((state) => {
      const draftIndex = state.drafts.findIndex((draft) => draft.role === role);
      if (draftIndex !== -1) {
        // Update existing draft
        state.drafts[draftIndex] = { ...state.drafts[draftIndex], ...changes };
      } else {
        // Add new draft
        const newDraft: RoleInputState = {
          role,
          userAllowed: changes.userAllowed ?? null,
        };
        state.drafts.push(newDraft);
      }
      return state;
    });
  },
}));
